import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandHeader from '../login-screen/components/BrandHeader';
import LoginForm from '../login-screen/components/LoginForm';
import BackgroundPattern from '../login-screen/components/BackgroundPattern';
import { supabase } from '../../lib/supabase';

const ResetPasswordScreen = () => {
  const navigate = useNavigate();
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const processResetLink = async () => {
      try {
        // Verificar parâmetros na query string
        const searchParams = new URLSearchParams(window.location.search);
        const token = searchParams.get('token');
        const tokenHash = searchParams.get('token_hash');
        const type = searchParams.get('type');
        
        // Verificar parâmetros no fragmento da URL (parte após #)
        // Corrigir hash duplo que pode ocorrer em URLs malformadas
        const hash = window.location.hash.substring(1);
        const correctedHash = hash.replace(/#/g, '&');
        const fragmentParams = new URLSearchParams(correctedHash);
        const accessToken = fragmentParams.get('access_token');
        const refreshToken = fragmentParams.get('refresh_token');
        const fragmentType = fragmentParams.get('type');
        const emailFromHash = fragmentParams.get('email');
        
        // Fallback para sessionStorage
        const emailFromStorage = sessionStorage.getItem('reset_email');
        const resetEmail = emailFromHash || emailFromStorage;
        
        console.log('🔍 ResetPassword: URL completa:', window.location.href);
        console.log('🔍 ResetPassword: Search params:', window.location.search);
        console.log('🔍 ResetPassword: Fragment original:', window.location.hash);
        console.log('🔍 ResetPassword: Hash corrigido:', correctedHash);
        console.log('🔍 ResetPassword: Parâmetros encontrados:', { 
          token: !!token, 
          tokenHash: !!tokenHash, 
          type,
          accessToken: !!accessToken,
          refreshToken: !!refreshToken,
          fragmentType,
          resetEmail
        });
        
        // Priorizar fragment parameters (padrão do Supabase)
        if (accessToken && refreshToken && fragmentType === 'recovery') {
          // Usar tokens do fragment
          const { data, error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });
          
          if (error) {
            console.error('❌ Erro ao estabelecer sessão:', error);
            setError('Link de recuperação inválido ou expirado');
            return;
          }
          
          if (data.session) {
            console.log('✅ Sessão de reset estabelecida para:', data.session.user.email);
            if (resetEmail) {
              console.log('📧 Email sendo resetado:', resetEmail);
              // Validar se email da URL corresponde ao email da sessão
              if (resetEmail !== data.session.user.email) {
                console.warn('⚠️ Email da URL não corresponde ao email da sessão');
              }
            }
            setIsTokenValid(true);
            // Limpar parâmetros da URL
            window.history.replaceState({}, document.title, '/reset-password');
          } else {
            setError('Link de recuperação inválido ou expirado');
          }
        } else if (token && type === 'recovery') {
          // Fallback para query parameters
          const { data, error } = await supabase.auth.verifyOtp({
            token_hash: token,
            type: 'recovery'
          });
          
          if (error) {
            console.error('❌ Erro ao verificar token:', error);
            setError('Link de recuperação inválido ou expirado');
          } else {
            console.log('✅ Token verificado com sucesso:', data);
            if (resetEmail) {
              console.log('📧 Email sendo resetado:', resetEmail);
            }
            setIsTokenValid(true);
          }
        } else {
          setError('Link de recuperação inválido ou expirado');
        }
      } catch (err) {
        console.error('❌ Erro ao processar link de reset:', err);
        setError('Erro ao processar link de recuperação');
      } finally {
        setIsLoading(false);
      }
    };

    processResetLink();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Verificando link de recuperação...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="w-16 h-16 bg-error/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
            Link Inválido
          </h2>
          <p className="text-muted-foreground mb-6">
            {error}
          </p>
          <button
            onClick={() => navigate('/forgot-password')}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
          >
            Solicitar novo link
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <BackgroundPattern />
      <div className="relative z-10 min-h-screen flex flex-col">
        <div className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-md">
            <BrandHeader />
            {isTokenValid && <LoginForm mode="reset-password" />}
          </div>
        </div>
        
        {/* Footer */}
        <div className="py-6 text-center">
          <p className="text-xs text-muted-foreground font-caption">
            © 2024 Major High Academy. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordScreen;
